import { Button, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { workflowInstanceData } from '../../../helpers/workflow';

export function showCloseModal(
  workflowInstance,
  setOpenDispositionExternal,
  standardDialog,
  i18n,
  overrides = {}
) {
  if (!workflowInstance || workflowInstance.status === 'Close') {
    return;
  }

  const workflowRules = workflowInstanceData(workflowInstance, 'rules') ?? {};

  const { closeWorkflow = false, message = null } = {
    ...workflowRules,
    ...overrides,
  };

  if (!closeWorkflow) {
    return;
  }

  const handleClose = () => {
    standardDialog.close();
  };

  const handleProceed = () => {
    standardDialog.close();
    setOpenDispositionExternal(true);
  };

  standardDialog.open(
    <Stack direction="column" spacing={2} m={2}>
      <DialogTitle sx={{ mb: 2 }}>End {workflowInstance?.workFlow?.name}</DialogTitle>

      <DialogContent>
        <Stack direction="column" spacing={1}>
          {Boolean(message) && (
            <Typography variant="body1">
              {i18n(`case.details.workflow.message.${message}`, 'crs')}
            </Typography>
          )}

          <Typography variant="body2" color="text.secondary">
            {i18n('case.details.workflow.message.subText', 'crs')}
          </Typography>
        </Stack>
      </DialogContent>

      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <Button variant="text" onClick={handleClose}>
          {i18n('case.details.workflow.continue', 'crs')}
        </Button>

        <Button variant="contained" onClick={handleProceed}>
          {i18n('case.details.workflow.proceed', 'crs')}
        </Button>
      </Stack>
    </Stack>,
    'sm'
  );
}
